/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";


const Home = () => {

    return (
        <div className="home">
            <h1>Find Your Repose</h1>
            <h3>Our goal is to improve your mental health and happiness.</h3>
            <h3 className="help">What can we help you with today?</h3>
            <div className="buttons">
                <a href="" class="pill-btn">Improve Sleep Quality</a><br />
                <a href="" class="pill-btn">Reduce stress and anxiety</a><br />
                <a href="" class="pill-btn">Improve Focus</a><br />
                <a href="" class="pill-btn">Self Improvement</a><br />
                <a href="" class="pill-btn">Something else?</a><br />
            </div>
        </div>


    );
}

export default Home;